module.exports = function() {
  return new Worker(__webpack_public_path__ + "8ae29b8bfc4c8e218e99.worker.js");
};